import { PawPrint, Heart, ShoppingBag, Stethoscope, ExternalLink, Home, Dog } from "lucide-react";

const PET_LINKS = [
  { name: "Petco", icon: ShoppingBag, url: "https://www.petco.com", color: "bg-blue-600" },
  { name: "PetSmart", icon: ShoppingBag, url: "https://www.petsmart.com", color: "bg-red-600" },
  { name: "Chewy", icon: ShoppingBag, url: "https://www.chewy.com", color: "bg-blue-700" },
  { name: "ASPCA", icon: Heart, url: "https://www.aspca.org", color: "bg-orange-600" },
  { name: "SPCA Adopt", icon: Home, url: "https://www.aspca.org/adopt-pet", color: "bg-purple-600" },
  { name: "Petfinder", icon: PawPrint, url: "https://www.petfinder.com", color: "bg-purple-700" },
  { name: "Adopt-a-Pet", icon: Heart, url: "https://www.adoptapet.com", color: "bg-green-600" },
  { name: "Pet Health", icon: Stethoscope, url: "https://www.petmd.com", color: "bg-teal-600" },
  { name: "VCA Hospitals", icon: Stethoscope, url: "https://vcahospitals.com", color: "bg-blue-500" },
  { name: "Pet Insurance", icon: Heart, url: "https://www.petinsurance.com", color: "bg-green-700" },
  { name: "Dog Training", icon: Dog, url: "https://www.akc.org/expert-advice/training/", color: "bg-yellow-600" },
  { name: "Cat Care", icon: PawPrint, url: "https://www.catster.com", color: "bg-orange-500" },
  { name: "Pet Supplies+", icon: ShoppingBag, url: "https://www.petsuppliesplus.com", color: "bg-red-500" },
  { name: "1800PetMeds", icon: Stethoscope, url: "https://www.1800petmeds.com", color: "bg-cyan-600" },
];

const PetsAnimalsPanel = ({ roomId }) => {
  if (roomId !== "pets-animals") return null;

  const openLink = (url) => {
    window.open(url, '_blank', 'noopener,noreferrer');
  };

  return (
    <div className="retro-window mb-2" data-testid="pets-animals-panel">
      <div className="retro-title-bar px-2 py-1">
        <span className="flex items-center gap-1">
          <PawPrint className="w-4 h-4" />
          🐾 PETS & ANIMALS
        </span>
      </div>

      <div className="p-2 bg-gradient-to-b from-amber-50 to-orange-50 max-h-[300px] overflow-y-auto retro-scrollbar">
        <div className="space-y-1">
          {PET_LINKS.map((link, index) => {
            const Icon = link.icon;
            return (
              <button
                key={index}
                className={`${link.color} hover:opacity-90 text-white rounded w-full p-1.5 transition-all flex items-center gap-2 text-xs`}
                onClick={() => openLink(link.url)}
              >
                <Icon className="w-4 h-4 flex-shrink-0" />
                <span className="font-bold truncate">{link.name}</span>
                <ExternalLink className="w-3 h-3 ml-auto flex-shrink-0 opacity-70" />
              </button>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default PetsAnimalsPanel;
